// extracted by mini-css-extract-plugin
module.exports = {"root":"menu_root__S0qa4"};